module.exports = "https://web-assets.ifttt.com/packs/media/icons-v2/turned_on-92f74f06.svg";